//imports
import React, { useEffect, useState } from 'react';
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from 'react-redux';
import { HasPermission } from "Core/security"

import {
    //Tabs, 
    //TabContainer, 
    Container
} from '@gpstrackit/gtc-react-controls';

import Tabs, { TabContainer } from 'Components/Tabs';

import Forms from './components/forms';
import Answers from './components/answers';

import {
    catalogLoad
} from 'Redux/actions';

import {
    getDynamicForms
} from './components/answers/redux/slice';

const DynamicFormsMain = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const [currentTab, setCurrentTab] = useState(0);

    useEffect(() => {
        dispatch(catalogLoad(["drivers", "tags"]));
        dispatch(getDynamicForms({}));
    }, []);

    return (
        <Container>
            <Tabs
                tab={currentTab}
                onChange={(newTab) => setCurrentTab(newTab)}
            >
                <TabContainer
                    index={0}
                    label={messages['dynamicFormsMain_forms']}
                >
                    <Forms setCurrentTab={setCurrentTab} />
                </TabContainer>

                <TabContainer
                    index={1}
                    label={messages['dynamicFormsMain_answers']}
                >
                    <Answers setCurrentTab={setCurrentTab} />
                </TabContainer>
            </Tabs>
        </Container>
    );
}

export default DynamicFormsMain;